import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-wire',
  templateUrl: './icon-wire.component.html',
  styles: []
})
export class IconWireComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
